import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable()
export class PiErrorInterceptor implements HttpInterceptor {
  constructor(private _injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      filter((event: HttpEvent<any>) => event instanceof HttpResponse),
      switchMap((response: HttpResponse<any>) => {
        if (response.status !== 200 || !response.body.error)
          return of(response);

        const { error } = response.body;
        const { code, message } = error;

        return this._injector
          .get(TranslateService)
          .get(`PI.ERROR-CODE.${code}`)
          .pipe(
            map((translatedError: string) => {
              return response.clone({
                body: {
                  ...response.body,
                  error: {
                    ...error,
                    message: translatedError.includes('PI.ERROR-CODE')
                      ? message
                      : translatedError
                  }
                }
              });
            })
          );
      })
    );
  }
}
